export const MONITOREOS_ESPECTACULARES = 1;
export const MONITOREOS_MEDIOS_IMPRESOS = 2;
export const MONITOREOS_INTERNET = 3;
export const MONITOREOS_VISITAS_VERIFICACION = 4;

// Tipos de visita
export const EVENTOS = 6;
export const CASAS = 7;

// TipoActa
export const ACTA_INICIO = 1;
export const ACTA_HALLAZGO = 2;
export const ACTA_CIERRE = 3;
